import React, {useState, useEffect} from "react";
import ReactDOM from 'react-dom/client';
import { ethers } from "ethers";
import Header from "./components/Header";
import Body from "./components/Body";




function App() {
    

  
  return (
      <div>
        <Header />
        <Body />
      </div>
    )

}

export default App;
